<template>
  <div>
    <div class="d-flex align-items-center mr-auto px-2 pt-2">
      <button
        :class="['btn btn-sm rounded-circle p-25 cursor-pointer', isDark ? 'btn-danger' : 'btn-primary']"
        @click="goBack()"
      >
        <i class="feather icon-arrow-left arrow-icon"></i>
      </button>
      <div class="ml-1 text-capitalize text-dark cursor-pointer goback-text" @click="goBack()">
        {{ $t("go_back") }}
      </div>
    </div>
    <b-card class="m-2 p-1" no-body>
      <div v-if="loadingSearchDvr" class="d-flex justify-content-center my-2">
        <b-spinner label="Loading" variant="primary" />
      </div>
      <template v-else>
        <template v-if="hanwhaDvr">
          <h4 class="mb-3">Configuración de DVR {{ hanwhaDvr.name }}</h4>
          <b-tabs
            v-model="activeTab"
            vertical
            pills
            nav-wrapper-class="w-25 px-1"
             nav-class="text-left"
          >
            <b-tab v-for="(tab, index) in tabs" :key="index">
              <template #title>
                <feather-icon :icon="tab.icon" /> {{ tab.title }}
              </template>

              <keep-alive>
                <component
                   v-if="activeTab === index"
                  :is="tabs[activeTab].component"
                  :hanwhaDvr="hanwhaDvr"
                />
              </keep-alive>
            </b-tab>
          </b-tabs>
        </template>
        <b-alert
          v-else
          show="configRecordingInProccess"
          variant="warning"
          class="p-1 mb-1"
        >
          Sin información de dvr
        </b-alert>
      </template>

    </b-card>
  </div>
</template>

<script>
import { computed,onMounted,ref } from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import axios from '@axios'
import store from "@/store";
import router from "@/router";
import DeviceInfo from "./DeviceInfo.vue";
import DiskInfo from "./DiskInfo.vue";
import NetworkInfo from "./NetworkInfo.vue";
import NetworkConfig from './dvr-config-network/Index.vue';
import AdminRecord from "./AdminRecord.vue";
import GroupsInfo from "./dvr-groups/GroupsInfo.vue";
import UsersInfo from "./dvr-users/UsersInfo.vue";
import RecordConfig from "./RecordConfig.vue";
import DateTimeLanguageConfig from "./DateTimeLanguageConfig.vue";

export default {
  setup () {
    //HOOKS
    onMounted(async () => await getDvr());

    //COMPOSABLES
    const { t,tc } = useI18nUtils();

    //DATA
    const activeTab = ref(0);

    const hanwhaDvr = ref(null);

    const loadingSearchDvr = ref(false);

    const tabs = ref([
      {
        component: DeviceInfo,
        icon: 'InfoIcon',
        title: t('hanwha_dvr.deviceInfo')
      },
      {
        component: DiskInfo,
        icon: 'HardDriveIcon',
        title: t('hanwha_dvr.disk_info')
      },
     /*  {
        component: NetworkInfo,
        icon: 'WifiIcon',
        title: t('hanwha_dvr.network_info')
      }, */
      {
        component: NetworkConfig,
        icon: 'RadioIcon',
        title: t('hanwha_dvr.networkConfig')
      },
      {
        component: AdminRecord,
        icon: 'CircleIcon',
        title: t('hanwha_dvr.adminRecord')
      },
      {
        component: GroupsInfo,
        icon: 'MenuIcon',
        title: tc('hanwha_dvr.groups', 2)
      },
      {
        component: UsersInfo,
        icon: 'UsersIcon',
        title: tc('users.title', 2)
      },
      {
        component: RecordConfig,
        icon: 'VideoIcon',
        title: t('hanwha_dvr.recordConfig')
      },
      {
        component: DateTimeLanguageConfig,
        icon: 'CalendarIcon',
        title: t('hanwha_dvr.dateTimeLanguageConfig')
      }
    ]);

    //COMOUTED
    const isDark = computed(() => store.state.appConfig.layout.skin === "dark");

    //METHODS
    const getDvr = async () => {
      const { params } = router.currentRoute;

      loadingSearchDvr.value = true;

      await axios.get(`v1/hanwha/dvr/${params.id}`)
        .then(response => {
          const { data } = response;

          hanwhaDvr.value = data.data;
        })
        .catch(() => {
          hanwhaDvr.value = null;
        })
        .then(() => {
          loadingSearchDvr.value = false;
        });
    }

    const goBack = () => {
      router.push({ name: 'hanwha_dvr' });
    }

    return {
      activeTab,
      hanwhaDvr,
      loadingSearchDvr,
      tabs,

      isDark,

      goBack
    }
  }
}
</script>

<style scoped>
::v-deep .nav-pills .nav-link {
  justify-content: flex-start;
  font-size: 1.05rem;
}
</style>
